"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  angular.module('lr.Properties').controller('PropertiesCtrl', PropertiesCtrl);
  PropertiesCtrl.$inject = ['PropertiesFactory', '$routeParams', 'Utils', '$scope', 'formFilters', 'propertyFormConstants', '$filter', '$location', 'dataEvents', 'eventTypes', 'PropertyStateValue', 'AccountSetttingsService'];
  /* @ngInject */

  function PropertiesCtrl(PropertiesFactory, $routeParams, Utils, $scope, formFilters, propertyFormConstants, $filter, $location, dataEvents, eventTypes, PropertyStateValue, AccountSetttingsService) {
    var event = Utils.Publisher.subscribe(Utils.DateKeeper.event, function () {
      getPropertiesByDate();
      vm.currentDate = Utils.DateKeeper.getDate();
    });
    $scope.$on('$destroy', function () {
      destroy();
    });
    /* jshint validthis: true */
    //view modal

    var vm = this;
    vm.activate = activate;
    vm.dataLoading = false;
    vm.title = 'PropertiesCtrl';
    vm.filters = propertyFormConstants;

    vm.fetchProperties = function () {
      vm.pageChanged();
    };

    var propertyStateEvents = Utils.Publisher.subscribe(dataEvents.propertyState, function (propertyState, message) {
      if (message.hasOwnProperty('liveRezEventTypeID') && message.hasOwnProperty('propertyState')) {
        vm.propertiesData.forEach(function (property) {
          if (property.pageDataID === message.pageDataID) {
            // console.log('replace whole state object for ' + property.pageDataID);
            property.state = message.propertyState;
          }
        });
      }
    });
    activate(); ////////////////

    function activate() {
      vm.form = formFilters.getData();
      vm.propertiesData = [];
      vm.pageSize = 50;
      vm.currentPage = -1; //page for the paging

      vm.errorMsg = null;
      vm.isPropertyFetchDisabled = true;
      vm.form = angular.extend({}, vm.form, getUrlParams($routeParams.filter));
      vm.pageChanged = setEndPoint(vm.form);
      vm.submitForm = submitForm;
      vm.typeAhead = typeAhead;
      vm.inactive = true; //this is bad, but it works for now

      vm.form['Arrivals'] = vm.form['Arrivals'] === undefined ? false : vm.form['Arrivals'];
      vm.form['Departures'] = vm.form['Departures'] === undefined ? false : vm.form['Departures'];
      vm.form['SameDay'] = vm.form['SameDay'] === undefined ? false : vm.form['SameDay']; //this is bad, but it works for now

      vm.form['Occupied'] = vm.form['Occupied'] === undefined ? false : vm.form['Occupied'];
      vm.form['Unoccupied'] = vm.form['Unoccupied'] === undefined ? false : vm.form['Unoccupied']; //this is bad, but it works for now

      vm.form['ReadyState'] = vm.form['ReadyState'] === undefined ? false : vm.form['ReadyState'];
      vm.form['NotReady'] = vm.form['NotReady'] === undefined ? false : vm.form['NotReady'];
      vm.form['InProgressState'] = vm.form['InProgressState'] === undefined ? false : vm.form['InProgressState'];
      vm.form['PendingState'] = vm.form['PendingState'] === undefined ? false : vm.form['PendingState'];
      vm.form['FlaggedState'] = vm.form['FlaggedState'] === undefined ? false : vm.form['FlaggedState'];
      vm.checkInsOut = setDropDowns(vm.filters.checkInsOut, vm.form); //vm.filters.checkInsOut[0];

      vm.occupancy = setDropDowns(vm.filters.occupancy, vm.form);
      vm.status = setDropDowns(vm.filters.status, vm.form);
      vm.guestState = setDropDowns(vm.filters.guestState, vm.form);
      vm.pageChanged();
      AccountSetttingsService.getAccountSettings().then(function (data) {
        vm.accountSettings = data.data;
      }, function (error) {
        console.log(error);
      });
    }

    vm.onChangeCheckInsOut = function (cat, value) {
      //this is bad, but it works for now
      vm.form['Arrivals'] = false;
      vm.form['Departures'] = false;
      vm.form['SameDay'] = false;

      if (value._id === 0) {
        // set datekeeper date back to today
        $scope.$parent.App.dateCtrls.goToday();
        return;
      }

      for (var z = 0, len = vm.filters[cat].length; z < len; z++) {
        var filter = vm.filters[cat][z];

        if (filter.name === value.name) {
          vm.form[value.name] = true;
        }
      }
    };

    vm.onChangeOccupancy = function (cat, value) {
      //this is bad, but it works for now
      vm.form['Occupied'] = false;
      vm.form['Unoccupied'] = false;

      if (value._id === 0) {
        return;
      }

      for (var z = 0, len = vm.filters[cat].length; z < len; z++) {
        var filter = vm.filters[cat][z];

        if (filter.name === value.name) {
          vm.form[value.name] = true;
        }
      }
    };

    vm.onChangeStatus = function (cat, value) {
      //this is bad, but it works for now
      vm.form['ReadyState'] = false;
      vm.form['NotReady'] = false;
      vm.form['InProgressState'] = false;
      vm.form['PendingState'] = false;
      vm.form['FlaggedState'] = false;

      if (value._id === 0) {
        return;
      }

      for (var z = 0, len = vm.filters[cat].length; z < len; z++) {
        var filter = vm.filters[cat][z];

        if (filter.name === value.name) {
          vm.form[value.name] = true;
        }
      }
    };

    vm.onChangeGuestState = function (cat, value) {
      vm.form["CheckedInToday"] = value._id === 1;
      vm.form["CheckedOutToday"] = value._id === 2;
      vm.form["NotCheckedIn"] = value._id === 3;
      vm.form["NotCheckedOut"] = value._id === 4;
    };

    function setDropDowns(dropDownList, form) {
      for (var key in form) {
        if (form.hasOwnProperty(key)) {
          var data = form[key];

          if (data) {
            for (var z = 0, len = dropDownList.length; z < len; z++) {
              var value = dropDownList[z];

              if (value.name === key) {
                return dropDownList[z];
              }
            }
          }
        }
      }

      return dropDownList[0]; //return the default list
    }

    function getUrlParams(routeParams) {
      var returnForm = {};

      if (routeParams) {
        if (_typeof(routeParams) === 'object') {
          for (var i = 0, len = routeParams.length; i < len; i++) {
            var key = routeParams[i];
            returnForm[key] = true;
          }
        } else {
          returnForm[routeParams] = true;
        }
      }

      return returnForm;
    }

    function setEndPoint(form) {
      return getFilteredData;
      /*
      if (checkValues(form)) {
        return getFilteredData;
      } else {
        return getDefaultData;
      }
      */
    }

    function typeAhead(val) {
      if (vm.search) {
        vm.form['Keyword'] = val;
      }

      return PropertiesFactory.pageProperties(vm.currentPage, vm.pageSize, Utils.DateKeeper.getDate(), null, vm.form).then(function (data) {
        return data.aaData;
      });
    }

    function destroy() {
      Utils.Publisher.unsubscribe(event);
      Utils.Publisher.unsubscribe(propertyStateEvents);
    }

    function submitForm(page) {
      vm.propertiesData = [];
      vm.pageChanged = setEndPoint(vm.form);
      vm.pageChanged(page);
    }

    function checkValues(data) {
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          var ifTrue = data[key];

          if (ifTrue) {
            return true;
          }
        }
      }

      return false;
    }

    function getPropertiesByDate() {
      vm.dataLoading = true;
      vm.propertiesData.length = 0;
      vm.currentPage = 0;
      vm.errorMsg = '';
      PropertiesFactory.pageProperties(vm.currentPage, vm.pageSize, Utils.DateKeeper.getDate(), null, vm.form).then(function (data) {
        data = $filter('filter')(data.aaData, {
          active: +vm.inactive
        });

        if (data.length <= 0) {
          vm.errorMsg = 'No Property Data';
        }

        vm.propertiesData = data;
        vm.isPropertyFetchDisabled = false;
        vm.dataLoading = false;
      })["catch"](function (data) {
        console.log(data); //todo: errors?

        vm.errorMsg = 'No Property Data';
        vm.dataLoading = false;
      });
    }

    function getFilteredData(page) {
      vm.dataLoading = true;

      if (page !== undefined) {
        vm.currentPage = page;
      } //if we have an object grab the pagedataid


      if (_typeof(vm.search) === 'object') {
        vm.form['Keyword'] = vm.search.pageDataID + ''; //force to be a string
      } else {
        vm.form['Keyword'] = vm.search; //just grab the keyword from the search input.
      }

      if (vm.form.hasOwnProperty('Keyword') && typeof vm.form.Keyword === 'string' && !vm.form.Keyword.trim()) {
        delete vm.form.Keyword;
      } //starts from 0 for paging


      vm.currentPage++;
      vm.isPropertyFetchDisabled = true;
      PropertiesFactory.pageProperties(vm.currentPage, vm.pageSize, Utils.DateKeeper.getDate(), null, vm.form).then(function (data) {
        data = $filter('filter')(data.aaData, {
          active: +vm.inactive
        });

        if (data.length <= 0) {
          vm.errorMsg = 'No Property Data';
        }

        if (vm.currentPage > 0) {
          vm.propertiesData = vm.propertiesData.concat(data);
          vm.isPropertyFetchDisabled = false;
        } else {
          vm.propertiesData = data;
          vm.isPropertyFetchDisabled = false;
        }

        vm.dataLoading = false;
      })["catch"](function (data) {
        console.log(data); //todo: errors?

        vm.errorMsg = 'No Property Data';
        vm.dataLoading = false;
      });
    }

    function getDefaultData(page) {
      vm.dataLoading = true;

      if (page !== undefined) {
        vm.currentPage = page;
      } //starts from 0 for paging


      vm.currentPage++; //vm.isPropertyFetchDisabled = true;

      PropertiesFactory.getDefaultProperties(vm.currentPage, vm.pageSize).then(function (data) {
        data = $filter('filter')(data, {
          active: +vm.inactive
        });

        if (vm.currentPage > 0) {
          if (data.length > 0) {
            vm.propertiesData = vm.propertiesData.concat(data);
            vm.isPropertyFetchDisabled = false;
          }
        } else {
          vm.propertiesData = data;
          vm.isPropertyFetchDisabled = false;
        }

        vm.dataLoading = false;
      })["catch"](function (data) {
        console.log(data); //todo: errors?

        vm.dataLoading = false;
      });
    }
  }
})();